export const APP_ROUTES = {
  BASE: '/',
  LOGIN: '/login',
  PORTFOLIOS: '/portfolios',
  PORTFOLIO: '/portfolio/:id',
  ACCOUNT: '/account/:id',
  WF_FORECAST: '/wfforecast',
};
